import ActivityCard from '../components/profile/ActivityCard'
import ShowInfo from '../components/profile/ShowInfo'
import EditInfo from '../components/profile/EditInfo'
import { useContext, useState, useEffect } from 'react'
import ProfileContext from '../components/contexts/ProfileContext'
import GeneralContext from '../components/contexts/GeneralContext'
import ParticipantList from '../components/home/ParticipantList'
import CommentsList from '../components/home/CommentsList'

function GuestPage({ username }) {
   const { guestPageData } = useContext(GeneralContext)
   const { isEditing} = useContext(ProfileContext)
   const { getGuestUsersPosts,filterNow, filterUpcoming, filterRecent } = useContext(ProfileContext)
   const { showParticipants, setShowParticipants, showComments, setShowComments } = useContext(GeneralContext)

   const [nowActivities, SetNowActivities] = useState([])
   const [upcomingActivities, SetUpcomingActivities] = useState([])
   const [recentActivities, SetRecentActivities] = useState([])

      useEffect(() => {
         document.title = "Profile";
         document.documentElement.lang = "en";
   }, []);

    // function that builds a string to display user friendly looking time
    const fix_string = (time) => {
      var split_time = time.split(':')
      var build = ''
      var hour = 0

      if (parseInt(split_time[0]) > 12) {
         hour = parseInt(split_time[0]) - 12
         build = hour.toString() + ':' + split_time[1] + ' PM'
      } else if (parseInt(split_time[0]) == 0) {
         build = '12: ' + split_time[1] + ' AM'
      } else if (parseInt(split_time[0]) == 12) {
         build = '12: ' + split_time[1] + ' PM'
      } else {
         build = split_time[0] + ':' + split_time[1] + ' AM'
      }

      return build
   }

   useEffect(() => {
      const interval = setInterval(async () => {
         var postObj = await getGuestUsersPosts(guestPageData.id)
         
         if(postObj == null){postObj = []}

         const nowObj = await filterNow(postObj)
         const upcomingObj = await filterUpcoming(postObj)
         const recentObj = await filterRecent(postObj)

         // console.log(nowObj);
         if (postObj) {
            // console.log("Creating Now List");
            const nowList = await Promise.all(
               nowObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                            status={p.RecipientUserID}
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetNowActivities(nowList)

            const upcomingList = await Promise.all(
               upcomingObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                            status={p.RecipientUserID}
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetUpcomingActivities(upcomingList)

            const recentList = await Promise.all(
               recentObj.map((p) => {
                  return (
                     <div className="h-activity" key={p.id}>
                        <ActivityCard
                            name={p.author.attributes.name}
                            img_link={p.author.attributes.profile_pic_src}
                            time={fix_string(p.attributes.endTime)}
                            activity={p.attributes.activity}
                            location={p.attributes.location}
                            status={p.RecipientUserID}
                            date={p.attributes.end_date}
                            start_time={fix_string(p.attributes.startTime)}
                            start_date={p.attributes.date}
                            activityID = {p.id}
                            authorID = {p.authorID}
                        />
                     </div>
                  )
               })
            )
            SetRecentActivities(recentList)
         } else {
            // console.log("No posts");
         }
      }, 1000)
      return () => clearInterval(interval)
   })

   return (
      <div className="profile_divider">
         <div className="profile_avatarSection">   
            <div className="avatarSection_avatar">
               <img
                  src={guestPageData.imageSrc}
                  alt={'Avatar'}
                  className="avatarSection_avatar_image"
               />
            </div>
            <div className="avatarSection_description">
               <div className="avatarSection_description_name">
                  {guestPageData.name}
               </div>
               <div className="avatarSection_description_tags">
                  <ul className="avatarSection_tagsList">
                  {(guestPageData.tags.status === "Freshman" || guestPageData.tags.status === '') && (<li className="tag_freshman">Freshman</li>)}
                  {(guestPageData.tags.status === "Sophomore" || guestPageData.tags.status === '') && (<li className="tag_sophomore">Sophomore</li>)}
                  {(guestPageData.tags.status === "Junior" || guestPageData.tags.status === '') && (<li className="tag_junior">Junior</li>)}
                  {(guestPageData.tags.status === "Senior" || guestPageData.tags.status === '') && (<li className="tag_senior">Senior</li>)}
                  {(guestPageData.tags.status === "Graduate" || guestPageData.tags.status === '') && (<li className="tag_graduate">Graduate</li>)}
                  </ul>
               </div>
               <div className="majorSection">
               <div className="major_text"><b>Major:</b> {guestPageData.tags.major}</div>
            </div>
               <div className="avatarSection_description_description">
                  {guestPageData.description}
               </div>
               <div className="avatarSection_description_buttons">
                  
               </div>
            </div>
         </div>
         <div className="profile_activities">
            {showParticipants && <ParticipantList />}
            {showComments && < CommentsList/>}
            <ul className="profile_activitiesNow">
               <p className="profile_activities_header">Happening Now</p>
               <li className="profile_activities_li">
                  {nowActivities}
               </li>
            </ul>
            <div className="profile_activitiesUpcoming">
               <ul className="profile_activitiesNow">
                  <p className="profile_activities_header">
                     Upcoming Activities
                  </p>
                  <li className="profile_activities_li">
                     {upcomingActivities}
                  </li>
               </ul>
            </div>
            <div className="profile_activitiesPast">
               <ul className="profile_activitiesNow">
                  <p className="profile_activities_header">Past Activities</p>
                  <li className="profile_activities_li">
                     {recentActivities}
                  </li>
               </ul>
            </div>
         </div>
      </div>
   )
}
export default GuestPage
